export const DEFAULT_MAX_DURATION = 300
export const DEFAULT_MIN_DURATION = 5
export const DEFAULT_OUTSTREAM_MAX_DURATION = 30
export const DEFAULT_OUTSTREAM_MIN_DURATION = 5

export const DEFAULT_VIDEO_AD_HEIGHT = 480
export const DEFAULT_VIDEO_AD_WIDTH = 640
export const DEFAULT_VIDEO_AD_SIZE = [
  DEFAULT_VIDEO_AD_WIDTH,
  DEFAULT_VIDEO_AD_HEIGHT
]

export const SECONDARY_VIDEO_AD_HEIGHT = 360
export const SECONDARY_VIDEO_AD_WIDTH = 480
export const SECONDARY_VIDEO_AD_SIZE = [
  SECONDARY_VIDEO_AD_WIDTH,
  SECONDARY_VIDEO_AD_HEIGHT
]

export const CACHE_URL = 'https://prebid.adnxs.com/pbc/v1/cache'

export const IMA_VIDEO_LOAD_TIMEOUT = 15000

export const CPM_TOFIXED_LIMIT = 2
export const CPM_TEST_VALUE = 20.0

export const FAILSAFE_WAIT = 3000
export const BID_REQUEST_WAIT = 1500

export const TEST_BID_FLOOR = 0.01

export const GAM_ADS_TAG_URL =
  'https://securepubads.g.doubleclick.net/gampad/live/ads'
export const GAM_SAMPLE_TAG_URL =
  'https://pubads.g.doubleclick.net/gampad/ads?slotname=/124319096/external/ad_rule_samples&sz=640x480&ciu_szs=300x250&cust_params=deployment%3Ddevsite%26sample_ar%3Dpremidpost&url=https://developers.google.com/interactive-media-ads/docs/sdks/html5/tags&unviewed_position_start=1&output=xml_vast3&impl=s&env=vp&gdfp_req=1&ad_rule=0&vad_type=linear&vpos=preroll&pod=1&ppos=1&lip=true&min_ad_duration=0&max_ad_duration=30000&vrid=6256&video_doc_id=short_onecue&cmsid=496&kfa=0&tfcd=0'
export const GAM_SKIPPABLE_TAG_URL =
  'https://securepubads.g.doubleclick.net/gampad/live/ads?sz=640x480&iu=/124319096/external/single_ad_samples&ciu_szs=300x250&impl=s&gdfp_req=1&env=vp&output=vast&unviewed_position_start=1&cust_params=deployment%3Ddevsite%26sample_ct%3Dskippablelinear&correlator='

// Note: There may be a better sample URL for non-linear overlay ads that
// points to doubleclick.net, but I was unable to find one.
export const GAM_SAMPLE_OVERLAY_TAG_URL =
  'https://g2.gumgum.com/video/tag?t=ini0hkav'
